import classNames from "classnames";
import { gridClasses } from "@mui/x-data-grid-pro";

import Tooltip from "features/components/Tooltip";

import RequiredMark from "./RequiredMark";

interface Props {
  label: string;
  description: string;
  required?: boolean;
}

// The title class keeps the grid's own header styling. That title clips its overflow, and at its line height the
// underline falls just below the text box, so the vertical padding makes room for it without moving the text. The
// tooltip describes the label rather than naming it: as a name it would replace the label as what a screen reader
// calls the column.
const DescribedColumnHeader = ({ label, description, required }: Props) => (
  <>
    <Tooltip title={description} underline describeChild>
      <div
        className={classNames(
          gridClasses.columnHeaderTitle,
          "py-1 font-medium"
        )}
      >
        {label}
      </div>
    </Tooltip>
    {required && <RequiredMark />}
  </>
);

export default DescribedColumnHeader;
